export default __webpack_public_path__ + "78e9ba00ab7030d0a47ff4e6c484cf46.svg";